export default class LimitedCharacterInput {
    private input: HTMLInputElement | HTMLTextAreaElement;
    private countElement: HTMLElement;
    private createRemainingText = () => {
        const div = document.createElement("div");
        div.className = "form-control-character-count";
        return div;
    }

    constructor(input: HTMLInputElement | HTMLTextAreaElement, maxlength: number) {
        this.input = input;
        // ignore count
        if (this.input.classList.contains("no-character-count")) {
            this.init = () => { };
        } else {
            // add maxlength
            this.input.maxLength = maxlength;
        }
    }

    init = () => {
        // add remaining text
        this.countElement = this.createRemainingText();
        this.input.after(this.countElement);

        // check character limit on key up and down
        this.input.addEventListener("keydown", this._updateCharacterCount);
        this.input.addEventListener("keyup", this._updateCharacterCount);

        // hide character count on blur
        this.input.addEventListener("blur", () => {
            this.countElement.classList.remove("show");
        });

        // hide character count on focus
        this.input.addEventListener("focus", () => {
            this.countElement.classList.add("show");
        });

        // update default character count
        this._updateCharacterCount();
    }

    private _updateCharacterCount = (e: KeyboardEvent = null) => {
        // ignore if more than limit
        if (this.input.value.length > this.input.maxLength) {
            this.input.value = this.input.value.substring(0, this.input.maxLength);
        }

        // update character count text
        const remaining = this.input.maxLength - this.input.value.length;
        if (remaining > 1) {
            this.countElement.textContent = `${remaining} characters remaining`;
        } else if (remaining == 1) {
            this.countElement.textContent = `${remaining} character remaining`;
        } else {
            this.countElement.textContent = `Maximum characters reached`;
        }
    }
}

$('.character-count').each((index, item: HTMLInputElement | HTMLTextAreaElement) => {
    new LimitedCharacterInput(item, item.maxLength).init();
});